import React, { useContext } from "react";
import "./body.css";
import Wizard from "../Wizard";
import AiButton from "../AI/components/AiButton/AiButton";
import { UserDataContext } from "../../UserContext";

/**
 * The Body component serves as a wrapper component.
 *
 * It renders the Wizard component within it.
 *
 * @param {Object} props - The props passed to this component.
 * @returns {React.ReactNode} A React element that renders the Wizard component.
 */
const Body = (props) => {
  const [userData] = useContext(UserDataContext);

  return (
    <div>
      <Wizard />
      {userData?.policy?.lorri_ai?.allowed === "yes" && <AiButton />}
    </div>
  );
};

export default Body;
